import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/machinery/forklift")({
  component: () => null,
  beforeLoad: () => {
    throw redirect({
      to: "/machinery/inspection",
      search: { type: "forklift" },
      replace: true,
    });
  },
});
